






































import { Watch, Prop, Component, Vue } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { AppConstants as _app } from "@/shared/app.constants";
import NegotiationLog from "./GrantsNegotiationLog.vue";
import HeaderInfo from './HeaderInfo.vue';

@Component({
  components: {
    NegotiationLog,
    HeaderInfo
  }
})
export default class GrantsActivityLogComponent extends Vue {
  @Prop() GrantInfo: any;
  @Prop() selectedGrant: any;
  log = [];
  showFeedback = false;
  ReportType = "All";

  /** Get the grant activity log */
  mounted() {
    const self = this;
     this.$services.summary.getGrantsNegotiationLog(this.selectedGrant)
     .then((resp)=>{
        if (resp.Result === "OK") {
          if (resp.Record && resp.Record.length > 0) {
            self.log = resp.Record.slice(0, resp.Record.length - 1);
            console.log(self.log)
          } else {
            self.log = [];
          }
        }
     });
  }

 ifFeedback(value) {
    const self = this;
    if(value.target.checked === true) {
      this.showFeedback = true;
      this.$services.summary
        .getGrantsNegotiationLog(this.selectedGrant)
        .then((resp) => {
          if (resp.Result === "OK") {
            if (resp.Record && resp.Record.length > 0) {
              self.log = resp.Record.filter(x => x.Type === 'Feedback');
            } else {
              self.log = []
            }
          }
        });
    } else {
      this.showFeedback = false;
      this.$services.summary
        .getGrantsNegotiationLog(this.selectedGrant)
        .then((resp) => {
          if (resp.Result === "OK") {
            if (resp.Record && resp.Record.length > 0) {
              self.log = resp.Record.slice(0, resp.Record.length - 1);
            } else {
              self.log = [];
            }
          }
        });
    }
  }

  changeFilter(e: any) {
    this.ReportType = e;
  }

  /** Check whether negotiation log exists */
  get showNegotiationLog() {
    if (this.GrantInfo.WorkflowInfo && this.GrantInfo.WorkflowInfo.LogStatus) {
      return (this.GrantInfo.WorkflowInfo.LogStatus.length > 0) ? true : false;
    } else {
      return false;
    }
  }
}
